module.exports = __webpack_public_path__ + "img/flag.42f026ff.svg";